module.exports = __webpack_public_path__ + "assets/img/modal-avatar-46b1eb28.png";